import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedFlex,
  Heading,
  Body,
} from '../../coreui';

import DynamicBrowseJoinLink from '../../helpers';
import CalloutFrame from '../../components/CalloutFrame';

import ImageBg from '../../assets/img_panel_homepage_approval.png';

const RightOpportunities = ({ isLoggedIn }) => {
  return (
    <CalloutFrame
      bg="black"
      image={ImageBg}
      imageType="image"
      imageProps={{
        mt: [0, 80, 100, 120, 140],
        mb: [60, 80, 100, 120, 140],
      }}
    >
      <Heading
        type="H2"
        mt={0}
        color="white"
      >
        DUE DILIGENCE STANDARDS
      </Heading>
      <Body
        type="B1"
        mb={0}
        color="white"
      >
        Since inception in 2012, the RealtyMogul platform has received over 30,000 real estate deals submitted.  As of January 1, 2021, the platform has hosted 337 of these transactions, or <em>just 1.1% of deals submitted</em>.  The due diligence review process is completed prior to every deal.
      </Body>
      <ExtendedFlex
        mt="auto"
        pt={20}
        mb={[null, null, 50]}
      >
        <DynamicBrowseJoinLink
          isLoggedIn={isLoggedIn}
          anonText="Get Started"
          type="L1"
        />
      </ExtendedFlex>
    </CalloutFrame>
  );
};

RightOpportunities.propTypes = {
  isLoggedIn: PropTypes.bool,
};

export default RightOpportunities;
